import { workspaceMainReducer } from './reducers/workspaceMain/reducer';
import { workspaceEventReducer } from './reducers/workspaceEvent/reducer';
import { scoreboardReducer } from './imports/components/Scoreboard/reducers/reducer';
export var workspaceMain = workspaceMainReducer;
export var workspaceEvent = workspaceEventReducer;
export var scoreboard = scoreboardReducer;



//////////////////
// WEBPACK FOOTER
// ./src/reducers.ts
// module id = 600
// module chunks = 0